// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableRow {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--datatable-line);
    width: -moz-fit-content;
    width: fit-content;
}

.SelectBox {
    width: 50px;
    left: 0;
    position: sticky;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 50px;
    height: 100%;
    z-index:2;
}

.RowEditActions {
  display: flex;
  position: sticky;
  right: 10px;
  z-index: 99;
  background-color: white;
}

/**********************************************************/
/*                  SpreadSheet                           */
/**********************************************************/
.SpreadSheetRow {
  display: flex;
  align-items: center;
}
.SpreadSheetCell {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    align-items: center;
    border: 1px solid var(--spreadsheet-line);
    color: var(--spreadsheet-cell-text);
}

/**********************************************************/
/*                  Resize & Select                       */
/**********************************************************/
.selectedRow {
  background-color: var(--primary-color) !important;
}

/*.selectedRow:hover {
  background-color: grey !important;
  color: white;
}

.selectedRow .Sticky {
  background-color: var(--primary-color) !important;
  color: white;
}

.selectedRow:hover .Sticky {
  background-color: grey !important;
  color: white;
}*/


.clickable {
  cursor: pointer;
}

.accept {
  color: green;
}

.accept:hover {
  color: green;
}

.cancel {
  color: red;
}

.cancel:hover {
  color: red;
}

.ExpandBox {
    width: 25px;
    height: 100%;
    left: 0;
    position: sticky;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 25px;
    background-color: white;
    z-index: 9;
}

.SpreadSheetCell.ExpandBox {
    overflow: initial;
}

.ExpandBox .material-icons {
    font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/datatable.row.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,OAAO;IAEP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,SAAS;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,iDAAiD;AACnD;;AAEA;;;;;;;;;;;;;EAaE;;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,OAAO;IAEP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".TableRow {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--datatable-line);\n    width: fit-content;\n}\n\n.SelectBox {\n    width: 50px;\n    left: 0;\n    position: -webkit-sticky;\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 0 0 50px;\n    height: 100%;\n    z-index:2;\n}\n\n.RowEditActions {\n  display: flex;\n  position: sticky;\n  right: 10px;\n  z-index: 99;\n  background-color: white;\n}\n\n/**********************************************************/\n/*                  SpreadSheet                           */\n/**********************************************************/\n.SpreadSheetRow {\n  display: flex;\n  align-items: center;\n}\n.SpreadSheetCell {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    height: 100%;\n    align-items: center;\n    border: 1px solid var(--spreadsheet-line);\n    color: var(--spreadsheet-cell-text);\n}\n\n/**********************************************************/\n/*                  Resize & Select                       */\n/**********************************************************/\n.selectedRow {\n  background-color: var(--primary-color) !important;\n}\n\n/*.selectedRow:hover {\n  background-color: grey !important;\n  color: white;\n}\n\n.selectedRow .Sticky {\n  background-color: var(--primary-color) !important;\n  color: white;\n}\n\n.selectedRow:hover .Sticky {\n  background-color: grey !important;\n  color: white;\n}*/\n\n\n.clickable {\n  cursor: pointer;\n}\n\n.accept {\n  color: green;\n}\n\n.accept:hover {\n  color: green;\n}\n\n.cancel {\n  color: red;\n}\n\n.cancel:hover {\n  color: red;\n}\n\n.ExpandBox {\n    width: 25px;\n    height: 100%;\n    left: 0;\n    position: -webkit-sticky;\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 25px;\n    background-color: white;\n    z-index: 9;\n}\n\n.SpreadSheetCell.ExpandBox {\n    overflow: initial;\n}\n\n.ExpandBox .material-icons {\n    font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
